import { defineStore, acceptHMRUpdate } from 'pinia'
import api from "../services/api.js";

export const useBulkSendStore = defineStore('bulkSends', {

    state: () => ({
        _templates: [],
        _bulk_sends: null,
        _bulk_send: null,
        _recipients: null,
        _preview: null,
    }),

    getters: {
        templates: (state) => state._templates,
        bulk_sends: (state) => state._bulk_sends,
        bulk_send: (state) => state._bulk_send,
        recipients: (state) => state._recipients,
        preview: (state) => state._preview,
        previewCounts: (state) => state._preview?.counts ?? null,
        previewRecipients: (state) => state._preview?.recipients ?? [],
    },

    actions: {
        async getTemplates() {
            const response = await api.get('auto-replies')
            this._templates = response.data
        },

        async previewBulkSend(params) {
            this._preview = null
            const response = await api.post('bulk-sends/preview', params)
            this._preview = response.data
        },

        async createBulkSend(params) {
            const response = await api.post('bulk-sends', params)
            return response.data
        },

        async getBulkSends(params) {
            const response = await api.get('bulk-sends', params)
            this._bulk_sends = response.data
        },

        async getBulkSend(uuid, params = {}) {
            const response = await api.get(`bulk-sends/${uuid}`, params)
            this._bulk_send = response.data.bulk_send
            this._recipients = response.data.recipients
        },

        async exportBulkSends(uuid)
        {
            await api.post(`bulk-sends/${uuid}/export`)
        },

        clearPreview() {
            this._preview = null
        },
    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useBulkSendStore, import.meta.hot))
}
